module.exports = __webpack_public_path__ + "img/Speaker=Rebecca Wellum.b9260e41.png";